/**
 * Contact form options.
 *
 * ⚠️  BOTH LISTS ARE VALIDATED SERVER-SIDE.
 * A value that is not in the matching enum in
 * `backend/src/models/contactModel.js` is rejected with a 400, so the two
 * files must be changed together. That coupling used to be invisible — the
 * options were hard-coded inside the form component with nothing pointing
 * at the server contract.
 *
 *   services → SERVICE_TYPES / SERVICE_LABELS   (numeric ids, append-only)
 *   budgets  → BUDGET_RANGES                    (exact strings)
 *
 * Service ids are stored on every past submission, so they are append-only:
 * never renumber one. Display order below is independent of the numbering —
 * the AI options lead because that is the site's positioning.
 *
 * Their position is the only emphasis they get, deliberately. Tinting them
 * was tried and removed: inside a form, colour reads as state, and an
 * unselected option sharing the selected colour looks already chosen.
 */

/** `id` must exist in SERVICE_TYPES; `label` is a translation key. */
export const configContactServices = [
  { id: '8', label: 'SectionContactUs.aiPilot' },
  { id: '6', label: 'SectionContactUs.aiAgents' },
  { id: '7', label: 'SectionContactUs.dataMl' },
  { id: '1', label: 'SectionContactUs.web' },
  { id: '2', label: 'SectionContactUs.mobile' },
  { id: '3', label: 'SectionContactUs.uiUx' },
  { id: '4', label: 'SectionContactUs.devOps' },
  { id: '5', label: 'SectionContactUs.qualityAssurance' },
];

/** Must match BUDGET_RANGES exactly, including spacing and currency format. */
export const configContactBudgets = [
  '$5,000 - $10,000',
  '$10,000 - $20,000',
  '$20,000 - $50,000',
  '$50,000 +',
];
